import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import { MessagesError } from '../classes/messages-error-type';
import { ErrorType } from '../enums/app-error-type';

@Component({
  selector: 'app-messages',
  templateUrl: './message-component.component.html',
  styleUrls: ['./message-component.component.scss'],
	encapsulation: ViewEncapsulation.Emulated
})
export class MessageComponent implements OnInit, OnChanges {
  @Input() msgArr: Array<MessagesError>;
  textArray: Array<string>;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.msgArr){
      this.textArray = this.msgArr.map(res => res.text);
    }
  }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/message-component/message-component.component.ts